<div><mat-form-field appearance="outline" class="search-filter">
    <mat-label>Sök</mat-label>
    <input matInput [(ngModel)]="searchTerm" (keyup)="filterSelectableValuesByQuery()" placeholder="Sök"
      class="search-input">
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>
</div>

<app-filter-button label="Område" [allValues]="this.allProductionTechnicianAreas"
  [(selectedValues)]="this.filterValues.productionTechnicianArea"
  (selectedValuesChange)="applyFilter()"></app-filter-button>
<app-filter-button label="Produktionsledare" [allValues]="this.allProductionLeaders"
  [(selectedValues)]="this.filterValues.productionLeader" (selectedValuesChange)="applyFilter()"></app-filter-button>
<app-filter-button label="Ägartyp" [allValues]="this.allOwnerTypes" [(selectedValues)]="this.filterValues.ownerType"
  (selectedValuesChange)="applyFilter()"></app-filter-button>
<app-filter-button label="Status" [allValues]="this.allStatuses" [(selectedValues)]="this.filterValues.status"
  (selectedValuesChange)="applyFilter()"></app-filter-button>
<app-filter-input-chips [(selectedValues)]="this.filterValues" (selectedValuesChange)="applyFilter()"
  [tableId]="'team-table'"></app-filter-input-chips>